import cn from 'classnames';
import styles from "./custom-image.module.scss";
import { Animate } from '../../animation/animation';
import { useEffect, useState } from 'react';

interface ICustomImageProps {
  src: string;
  imageObjectFit: string;
  active: boolean;
}

export function CustomImage({ imageObjectFit, src, active }: ICustomImageProps) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setLoading(false);
    }
  }, [src]);

  return ( 
    <Animate when={active} animation='fade' duration={600} delay={100}>
      {loading ? <div className={styles.placeholder}/>
        :
        <img 
          className={cn(styles.image, styles[imageObjectFit])} 
          src={src}
          alt=""
        />
      }
    </Animate>
  )
}